import React from "react";
import "./web.css";

function Web() {
  return (
    <div className="web">
      <div className="web-option">
        <a href="#about">
          <i className="fi fi-rr-user option-icon"></i>About
        </a>
      </div>
      <div className="web-option">
        <a href="#experience">
          <i className="fi fi-rr-briefcase option-icon"></i>Experience
        </a>
      </div>
      <div className="web-option">
        <a href="#projects">
          <i className="fi-rr-edit-alt option-icon"></i>Projects
        </a>
      </div>
      <div className="web-option">
        <a href="#skills">
          <i className="fi-rr-laptop option-icon"></i>Skills
        </a>
      </div>
      <div className="web-option">
        <a href="#contact">
          <i className="fi fi-rr-envelope option-icon"></i>Contact
        </a>
      </div>
      <div className="web-option web-dropdown">
        <span className="web-dropdown-toggle">
          <i className="fi fi-rr-menu-dots option-icon"></i>More
          <i className="fi fi-rr-angle-small-down dropdown-caret"></i>
        </span>
        <div className="web-dropdown-menu">
          <a href="#competencies">
            <i className="fi fi-rr-bullseye-arrow option-icon"></i>Competencies
          </a>
          <a href="#work">
            <i className="fi fi-rr-diploma option-icon"></i>Certificates
          </a>
          <a href="#education">
            <i className="fi fi-rr-graduation-cap option-icon"></i>Education
          </a>
          <a href="#achievements">
            <i className="fi fi-rr-trophy option-icon"></i>Achievements
          </a>
        </div>
      </div>
    </div>
  );
}

export default Web;
